import type { CrudAdapter } from '@botto/core';
import { useCrudDataSource } from '@botto/core';
import { smsClient } from '../client';
import type { Stream, StreamCreate, StreamUpdate } from '../types';

export const streamsAdapter: CrudAdapter<Stream, StreamCreate, StreamUpdate> = {
  async list({ offset, limit, sortName, sortDirection }) {
    const { data, error } = await smsClient.GET('/streams/', {
      params: {
        query: {
          offset,
          limit,
          'sort.name': sortName ?? 'id',
          'sort.direction': (sortDirection ?? 'asc') as 'asc' | 'desc',
        },
      },
    });
    if (error) throw error;
    return { items: data?.items ?? [], total: data?.total ?? 0 };
  },
  async create(payload) {
    const { data, error } = await smsClient.POST('/streams/', {
      body: payload as StreamCreate & Record<string, unknown>,
    });
    if (error) throw error;
    return { id: data?.id ?? 0 };
  },
  async update(payload) {
    const { data, error } = await smsClient.PUT('/streams/', {
      body: payload as StreamUpdate & Record<string, unknown>,
    });
    if (error) throw error;
    return (data ?? payload) as Stream;
  },
  async byKey(id) {
    const { data, error } = await smsClient.GET('/streams/{item_id}', {
      params: { path: { item_id: Number(id) } },
    });
    if (error) throw error;
    return data as Stream;
  },
  async remove(id) {
    const { error } = await smsClient.DELETE('/streams/{item_id}', {
      params: { path: { item_id: Number(id) } },
    });
    if (error) throw error;
  },
};

export const streamsStore = useCrudDataSource(streamsAdapter);
